export const regionalSpeedLimit = {
  regionalSpeedLimitName: "限速分区名称",
  regionalSpeedLimitNameCannotBeEmpty: "请输入限速分区名称",
  locate: "定位",
  newRegionalSpeedLimit: "新建限速分区",
  editRegionalSpeedLimit: "编辑限速分区",
  regionalSpeedLimit: "区内限速",
  regionalSpeedLimitWithUnit: "区内限速 ({0})",
  tips: "备注: 分区外按设备设定的限速值告警",
  maxSpeedLimitCannotBeEmpty: "请输入区内限速",
  speedLimit: "限速",
  bindVehiclesToThisRegionalSpeedLimit: "应用限速分区并设置警示规则",
  confirmDeletionContent:
    "限速分区“{name}”将被删除。确定要继续吗？ | 限速分区“{name}”将被删除，该限速分区有关联设备。确定要继续吗？",
  duplicateName: "此限速分区名称已存在。",
  cannotBeEmpty: "请在地图上绘制限速分区。",
  doesNotExists: "限速分区{name}不存在。",
  failedToAdd: "保存失败。",
  failedToDelete: "删除失败。",
  failedToEdit: "保存失败。",
};
